import { AfterViewInit, Component, inject } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { LoadingController, ModalController } from '@ionic/angular/standalone';
import { concatMap, filter, tap } from 'rxjs';
import { EventService } from '../../providers/event/event.service';

/**
 * @description App Overlay.
 * @exports
 * @class OverlayComponent
 * @implements {AfterViewInit}
 */
@Component({
  selector: 'app-overlay',
  template: ``,
  standalone: true
})
export class OverlayComponent implements AfterViewInit {
  private readonly events = inject(EventService);
  private readonly loadingCtrl = inject(LoadingController);
  private readonly modalCtrl = inject(ModalController);
  private readonly router = inject(Router);

  /**
   * @description Init.
   * @memberof OverlayComponent
   */
  ngAfterViewInit(): void {
    this.router.events
      .pipe(
        filter((e: Event): e is NavigationEnd => e instanceof NavigationEnd)
      )
      .pipe(
        concatMap(() => this.modalCtrl.getTop()),
        tap((modalCtrl) => {
          if (modalCtrl) modalCtrl.dismiss();
        })
      )
      .pipe(
        concatMap(() => this.loadingCtrl.getTop()),
        tap((loadingCtrl) => {
          if (loadingCtrl) loadingCtrl.dismiss();
        })
      )
      .subscribe(() => {
        //
      });

    this.events
      .listen(this.events.keys.MODAL_DISMISS)
      .subscribe(
        ({
          data,
          role,
          id
        }: {
          data: Parameters<ModalController['dismiss']>[0];
          role?: Parameters<ModalController['dismiss']>[1];
          id?: Parameters<ModalController['dismiss']>[2];
        }) => {
          this.modalCtrl.dismiss(data, role, id);
        }
      );
  }
}
